
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Nashiktomumbaiairportcab() {



    const cardData =
    {
        keyword: ' Nashik to Mumbai Airport Cab ',
        heading: 'Deva Cabs: Nashik to Mumbai Airport Cab   ',
        headingDescription: 'Deva Cabs offers safe and dependable cab services from Nashik to Mumbai Airport, ideal for travelers seeking comfort, punctuality, and reliability. Covering approximately 170 km, our cabs ensure a smooth ride with professional chauffeurs and well-maintained vehicles including Sedans, SUVs, and Innova Crysta. Whether it’s an early morning flight or a late-night arrival, Deva Cabs provides 24/7 pickups, fixed pricing, and door-to-door service to make your airport journey stress-free.',

        top: 'Top Places to Visit in Mumbai with Deva Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "location": "Mumbai, Maharashtra",
    "description": "The Gateway of India is Mumbai’s most iconic monument, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea and standing beside the Taj Mahal Palace Hotel, it is a popular starting point for ferry rides to Elephanta Caves and a must-visit historical attraction that symbolizes Mumbai’s colonial past and vibrant present."
  },
  {
    "title": "Marine Drive",
    "location": "Mumbai, Maharashtra",
    "description": "Marine Drive is a 3.6 km-long boulevard that curves along the coast from Nariman Point to Girgaon Chowpatty. Nicknamed the 'Queen’s Necklace' for its glittering lights at night, it's a favorite spot for peaceful walks, sunset views, and soaking in the coastal breeze with the city skyline as a backdrop."
  },
  {
    "title": "Elephanta Caves",
    "location": "Elephanta Island, Mumbai Harbour",
    "description": "A UNESCO World Heritage Site, Elephanta Caves are a group of ancient rock-cut temples located on Elephanta Island. Accessible via ferry from the Gateway of India, the caves date back to the 5th–8th centuries and are famous for intricate carvings of Lord Shiva, especially the iconic Trimurti sculpture."
  },
  {
    "title": "Siddhivinayak Temple",
    "location": "Prabhadevi, Mumbai, Maharashtra",
    "description": "Dedicated to Lord Ganesha, the Siddhivinayak Temple is one of Mumbai’s most important spiritual centers. Known for its majestic architecture and the black stone idol with a trunk curving to the right, the temple attracts devotees from all walks of life, especially on Tuesdays when thousands come for darshan."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "location": "Mumbai, Maharashtra",
    "description": "A UNESCO World Heritage Site, this historic railway station is an architectural marvel that combines Victorian Gothic with traditional Indian design. Built in 1887, it remains a bustling transport hub and a monument that reflects Mumbai's colonial legacy and artistic grandeur."
  },
  {
    "title": "Juhu Beach",
    "location": "Mumbai, Maharashtra",
    "description": "Juhu Beach is a lively stretch of coastline known for its street food stalls, Bollywood celebrity homes, and sunset views. From children playing cricket to couples strolling by the waves, the beach buzzes with energy and offers a quintessential Mumbai experience with snacks like vada pav and bhel puri."
  },
  {
    "title": "Haji Ali Dargah",
    "location": "Worli, Mumbai, Maharashtra",
    "description": "Situated on an islet off the coast of Worli, Haji Ali Dargah is a 15th-century Indo-Islamic shrine housing the tomb of Sufi saint Haji Ali Shah Bukhari. Accessible by a narrow causeway during low tide, the dargah offers spiritual tranquility along with breathtaking sea views."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "location": "Borivali, Mumbai, Maharashtra",
    "description": "One of the world’s few national parks within city limits, Sanjay Gandhi National Park is a green haven offering nature trails, a toy train, boating, and wildlife like leopards and deer. The park is also home to the ancient Kanheri Caves, which showcase Buddhist rock-cut architecture dating back over 2,000 years."
  },
  {
    "title": "Chor Bazaar",
    "location": "Bhendi Bazaar, Mumbai, Maharashtra",
    "description": "One of India’s oldest flea markets, Chor Bazaar is a treasure trove of antiques, vintage Bollywood posters, rare coins, and quirky collectibles. Despite its name meaning 'Thieves’ Market', it’s a legal and lively destination for bargain hunters and curious tourists alike."
  },
  {
    "title": "Girgaon Chowpatty",
    "location": "Girgaon, Mumbai, Maharashtra",
    "description": "Located at the northern end of Marine Drive, Girgaon Chowpatty is a city beach known for its festive spirit, street food, and cultural gatherings. It becomes especially vibrant during Ganesh Chaturthi, when thousands gather for idol immersions in the Arabian Sea."
  }
],



"services": [
  {
    "name": "Nashik to Mumbai Airport Cab",
    "description": "Deva Cabs provides reliable and comfortable taxi services from Nashik to Mumbai Airport, ensuring you reach your flight on time and in style. Our fleet includes a variety of well-maintained vehicles equipped with air-conditioning and ample luggage space. Whether you’re traveling solo, with family, or in a corporate group, our professional drivers offer punctual pickups, courteous service, and smooth rides along the best routes to Mumbai’s airport terminals."
  },
  {
    "name": "Cab from Nashik to Mumbai T2",
    "description": "Travel from Nashik directly to Mumbai Airport Terminal 2 (T2) with Deva Cabs. Our drivers are well-acquainted with the T2 terminal’s layout and procedures, ensuring timely and hassle-free drop-offs or pickups. Choose from sedans, SUVs, and luxury vehicles for a comfortable journey tailored to your preferences."
  },
  {
    "name": "One-way Nashik to Mumbai Airport taxi",
    "description": "Book a convenient one-way taxi service from Nashik to Mumbai Airport with Deva Cabs. Our transparent pricing and fixed fares guarantee no surprises. Ideal for travelers looking for a straightforward, reliable transfer without the need for a round trip, our one-way service focuses on comfort, punctuality, and safety."
  },
  {
    "name": "Chauffeur cab Nashik to Airport Mumbai",
    "description": "Enjoy a premium chauffeur-driven experience with Deva Cabs when traveling from Nashik to Mumbai Airport. Our trained and courteous drivers assist with luggage, navigate traffic efficiently, and provide a relaxing atmosphere throughout your journey. Perfect for business travelers and VIPs seeking stress-free airport transfers."
  },
  {
    "name": "Online booking Nashik to Mumbai Airport cab",
    "description": "Reserve your Nashik to Mumbai Airport cab effortlessly through our easy-to-use online booking system. Select your vehicle type, preferred pickup time, and route, and get instant confirmation. Our digital platform ensures a smooth reservation process with clear pricing and support at every step."
  },
  {
    "name": "SUV cab Nashik to Mumbai Airport",
    "description": "Travel comfortably with your family or group in one of our spacious SUVs from Nashik to Mumbai Airport. Our vehicles offer ample legroom, reclining seats, and sufficient luggage space. Equipped with modern amenities and air-conditioning, these SUVs provide a smooth ride on longer routes, ensuring your trip is enjoyable and relaxed."
  },
  {
    "name": "Luxury taxi Nashik to Mumbai Airport",
    "description": "Make your airport transfer an elegant affair with Deva Cabs’ luxury taxi service from Nashik to Mumbai Airport. Choose premium vehicles like Mercedes, Audi, or BMW with plush interiors, advanced climate control, and the latest entertainment systems. Our chauffeurs deliver a refined, punctual, and discreet service for special occasions and business needs."
  },
  {
    "name": "Affordable cab Nashik to Airport",
    "description": "Deva Cabs offers budget-friendly yet high-quality taxi options from Nashik to Mumbai Airport. Our affordable cabs do not compromise on comfort or safety, featuring clean, well-maintained vehicles and experienced drivers. Ideal for travelers who want value without sacrificing convenience."
  },
  {
    "name": "Nashik to Mumbai Airport drop cab",
    "description": "Our door-to-door drop cab service ensures you reach Mumbai Airport from Nashik smoothly and on time. Deva Cabs prioritizes punctuality and reliability, helping you avoid any last-minute rush. Our drivers track real-time traffic and flight schedules to provide seamless airport transfers."
  },
  {
    "name": "Family cab Nashik to Mumbai Airport",
    "description": "Travel safely with your entire family in our family-friendly cabs from Nashik to Mumbai Airport. Spacious seating, extra luggage room, and attentive service from our drivers make family trips comfortable and stress-free. We cater to all group sizes with appropriate vehicle options."
  },
  {
    "name": "24x7 cab Nashik to Airport",
    "description": "Deva Cabs offers round-the-clock taxi service from Nashik to Mumbai Airport to accommodate flights at any hour. Whether it’s an early morning departure or a late-night arrival, our 24x7 availability ensures you never miss a flight. Our drivers are experienced in nighttime driving and safety protocols."
  },
  {
    "name": "AC cab Nashik to Mumbai T2",
    "description": "Stay cool and comfortable on your trip from Nashik to Mumbai Airport T2 with our fully air-conditioned cabs. Deva Cabs maintains a fleet of sanitized, climate-controlled vehicles to provide you with the best travel experience regardless of Mumbai’s weather conditions."
  },
  {
    "name": "Nashik to Mumbai domestic terminal cab",
    "description": "Need a taxi to Mumbai’s domestic airport terminal from Nashik? Deva Cabs offers specialized transfers to the domestic terminal with punctual pickups and hassle-free drop-offs. Our drivers are familiar with terminal timings and security protocols to facilitate smooth transfers."
  },
  {
    "name": "Round trip Nashik to Airport cab",
    "description": "Book a convenient round trip taxi from Nashik to Mumbai Airport with Deva Cabs. Ideal for those who want a hassle-free return journey arranged in advance, our round trip service guarantees vehicle availability, fixed pricing, and dependable drivers for both legs of your trip."
  },
  {
    "name": "Premium cab from Nashik to Mumbai Airport",
    "description": "Experience top-tier service with Deva Cabs’ premium cab offerings from Nashik to Mumbai Airport. Featuring luxury cars, professional chauffeurs, and priority support, our premium service ensures a sophisticated, comfortable, and timely airport transfer for discerning travelers."
  }
],
"tableData": [
  ["Nashik to Mumbai Airport Cab", "-Cab from Nashik to Mumbai T2"],
  ["One-way Nashik to Mumbai Airport taxi", "-Chauffeur cab Nashik to Airport Mumbai"],
  ["Online booking Nashik to Mumbai Airport cab", "-SUV cab Nashik to Mumbai Airport"],
  ["Luxury taxi Nashik to Mumbai Airport", "-Affordable cab Nashik to Airport"],
  ["Nashik to Mumbai Airport drop cab", "-Family cab Nashik to Mumbai Airport"],
  ["24x7 cab Nashik to Airport", "-AC cab Nashik to Mumbai T2"],
  ["Nashik to Mumbai domestic terminal cab", "-Round trip Nashik to Airport cab"],
  ["Premium cab from Nashik to Mumbai Airport", ""]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable and On-Time Nashik to Mumbai Airport Transfers",
    "WhyChoosedescription": "When traveling from Nashik to Mumbai Airport, time is of the essence. Our cab service is built around punctuality and efficiency to ensure you reach the airport well before your flight. Whether you're flying for business or leisure, we monitor traffic conditions and suggest the best departure time to avoid delays. Our drivers arrive promptly and follow optimized routes to guarantee on-time drop-offs."
  },
  {
    "WhyChooseheading": "Comfortable, Spacious, and Long-Distance Ready Vehicles",
    "WhyChoosedescription": "Enjoy a smooth and relaxing 4–5 hour journey from Nashik to Mumbai Airport in our clean, air-conditioned vehicles. Our fleet includes sedans, SUVs, and premium options with plush seating, ample legroom, and generous luggage space. Every cab is equipped to handle long-distance travel with comfort, so you arrive at the airport refreshed and stress-free."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Nashik-Mumbai Routes",
    "WhyChoosedescription": "Our professional drivers are seasoned in navigating the Nashik to Mumbai corridor, including Ghoti, Igatpuri, and the Expressway. They are trained for long-distance rides and emphasize safety, calm driving, and customer service. With local route knowledge and courteous behavior, they ensure your trip is smooth, secure, and enjoyable."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We offer fair and fully transparent rates for all Nashik to Mumbai Airport cab bookings. Your quote includes fuel, tolls, and driver allowances—no last-minute add-ons. Our clear pricing policy ensures you know exactly what you’ll pay upfront, so you can plan your travel budget with complete confidence."
  },
  {
    "WhyChooseheading": "24/7 Cab Service for Every Flight Schedule",
    "WhyChoosedescription": "No matter what time your flight departs or arrives, we’re here to serve you. Our Nashik to Mumbai Airport cabs are available round-the-clock, even during odd hours or peak travel days. We work around your flight timing to ensure stress-free travel, even for early morning check-ins or midnight landings."
  },
  {
    "WhyChooseheading": "Quick and Convenient Booking System",
    "WhyChoosedescription": "Booking your cab is fast and hassle-free through our website or helpline. You can reserve in advance or make a last-minute booking based on availability. With instant confirmations, simple payment options, and real-time support, we make it easy to schedule your journey with just a few clicks or a quick call."
  },
  {
    "WhyChooseheading": "Safe Travel with Well-Maintained Vehicles",
    "WhyChoosedescription": "Our fleet is regularly inspected and maintained to meet high safety standards. From GPS tracking and working seat belts to regular sanitization and emergency support, our Nashik to Mumbai Airport cabs are fully equipped to keep you and your family secure throughout the ride."
  },
  {
    "WhyChooseheading": "Customer-Centric Services for a Better Experience",
    "WhyChoosedescription": "We personalize every ride to match your specific needs. Whether you’re traveling with children, elderly passengers, or extra luggage, we accommodate your requests to ensure complete satisfaction. Our drivers are friendly, helpful, and trained to provide a professional yet warm customer experience every step of the way."
  }
]

















    }










const faqData = [
  {
    question: "Can I book a cab from Nashik to Mumbai Airport with Deva Cabs?",
    answer: "Yes, Deva Cabs offers dependable cab services from Nashik to Mumbai Airport for all types of travelers."
  },
  {
    question: "How long does it take to travel from Nashik to Mumbai Airport by cab?",
    answer: "The journey typically takes around 3.5 to 4.5 hours depending on traffic and road conditions."
  },
  {
    question: "What vehicle options are available for the Nashik to Mumbai Airport route?",
    answer: "We provide sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to cater to individual and group needs."
  },
  {
    question: "Can I pre-book a cab for Nashik to Mumbai Airport?",
    answer: "Yes, you can easily pre-book your cab via our website, mobile app, or by contacting customer support."
  },
  {
    question: "Are one-way cab services available from Nashik to Mumbai Airport?",
    answer: "Yes, Deva Cabs offers convenient one-way cab services without any return fare obligations."
  },
  {
    question: "Will the driver wait if my flight is delayed at Mumbai Airport?",
    answer: "Yes, our drivers monitor flight timings and adjust pickup times accordingly for your convenience."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Tolls and parking charges are usually extra and will be transparently communicated at booking."
  },
  {
    question: "Is the cab service available late night or early morning?",
    answer: "Yes, Deva Cabs operates 24/7, so you can book anytime from Nashik to Mumbai Airport."
  },
  {
    question: "Is it safe to travel alone in a cab from Nashik to Mumbai Airport?",
    answer: "Absolutely, all our drivers are verified and trained to ensure a safe and comfortable journey for all passengers."
  },
  {
    question: "Why choose Deva Cabs for Nashik to Mumbai Airport cab services?",
    answer: "We provide timely service, clean vehicles, professional drivers, and transparent pricing for a stress-free travel experience."
  }
];

const testimonialData = [
  {
    id: 23,
    name: 'Mr. Ajay Deshpande',
    role: 'Frequent Traveler',
    review: 'Used Deva Cabs for my trip from Nashik to Mumbai Airport. The driver was punctual and courteous, and the vehicle was very comfortable.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 24,
    name: 'Ms. Priyanka Kulkarni',
    role: 'Tourist',
    review: 'Booked a cab from Nashik to Mumbai Airport with Deva Cabs. Excellent service and smooth ride. Highly recommended!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];


































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Nashik to Mumbai Airport Cab",
  "image": "https://devacab.com/assets/images/nashik-to-mumbai-airport-cab.jpg", // Replace with actual image URL
  "description": "Book reliable and affordable Nashik to Mumbai Airport cab service with Deva Cabs. Choose from AC, SUV, luxury, and chauffeur-driven cabs for one-way, round trip, and 24x7 airport transfers with easy online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/nashik-to-mumbai-airport-cab" // Replace with actual page URL
  }
};




    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Nashik to Mumbai Airport Cab | Affordable & Reliable Airport Taxi | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Nashik to Mumbai Airport cab with Deva Cabs. Offering AC, SUV, luxury, and chauffeur-driven cabs for one-way, round trip, and 24x7 airport transfers. Easy online booking." 
  />
  <meta 
    name="keywords" 
    content="Nashik to Mumbai Airport Cab, Cab from Nashik to Mumbai T2, One-way Nashik to Mumbai Airport taxi, Chauffeur cab Nashik to Airport Mumbai, Online booking Nashik to Mumbai Airport cab, SUV cab Nashik to Mumbai Airport, Luxury taxi Nashik to Mumbai Airport, Affordable cab Nashik to Airport, Nashik to Mumbai Airport drop cab, Family cab Nashik to Mumbai Airport, 24x7 cab Nashik to Airport, AC cab Nashik to Mumbai T2, Nashik to Mumbai domestic terminal cab, Round trip Nashik to Airport cab, Premium cab from Nashik to Mumbai Airport" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/20.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Nashiktomumbaiairportcab;